const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

const extractHost = (hostPort: string) => {
  if (hostPort.startsWith("[")) {
    const closingBracket = hostPort.indexOf("]");
    return closingBracket === -1
      ? hostPort.slice(1)
      : hostPort.slice(1, closingBracket);
  }

  const colonCount = hostPort.split(":").length - 1;
  return colonCount === 1 ? hostPort.split(":")[0] : hostPort;
};

const tryParseHostname = (candidate: string) => {
  try {
    return new URL(candidate).hostname;
  } catch {
    return undefined;
  }
};

const parseHost = (value: string) => {
  const withoutScheme = value.replace(SCHEME, "");
  const [hostPort] = withoutScheme.split("?")[0].split("/");

  const hostname =
    tryParseHostname(SCHEME.test(value) ? value : `http://${value}`) ??
    tryParseHostname(`http://[${hostPort}]`);

  if (hostname) {
    return hostname.startsWith("[") ? hostname.slice(1, -1) : hostname;
  }
  return extractHost(hostPort);
};

export const normalizeNetworkValue = (value?: string | null) => {
  if (!value) return "";
  return parseHost(String(value).trim()).toLowerCase().replace(/\.$/, "");
};

export const normalizeUrlValue = (value?: string | null) =>
  value
    ? String(value)
        .trim()
        .replace(SCHEME, "")
        .split("?")[0]
        .replace(/\/$/, "")
        .toLowerCase()
    : "";

export const normalizeMutexValue = (value?: string | null) =>
  value ? String(value).trim().toLowerCase() : "";

export const matchesConfigC2 = (
  configHosts: Set<string>,
  configUrls: Set<string>,
  observedValue?: string | null
) => {
  if (configHosts.has(normalizeNetworkValue(observedValue))) return true;

  const observedUrl = normalizeUrlValue(observedValue);
  if (!observedUrl) return false;
  return Array.from(configUrls).some(configUrl =>
    observedUrl.endsWith(configUrl)
  );
};

export const matchesConfigMutex = (
  configMutexes: Set<string>,
  observedName?: string | null
) => {
  const observed = normalizeMutexValue(observedName);
  if (!observed) return false;
  return Array.from(configMutexes).some(configMutex =>
    observed.endsWith(configMutex)
  );
};

export const buildNormalizedSet = (
  values: Array<string | null | undefined>,
  normalizer: (value?: string | null) => string
) => new Set(values.map(normalizer).filter(Boolean));
